export default "__VITE_ASSET__CSroc_5b__"